import React from 'react';
import { useGeoPricing } from '../utils/geoPricing';
interface PriceDisplayProps {
  showOriginal?: boolean;
  className?: string;
}
export function PriceDisplay({
  showOriginal = true,
  className = ''
}: PriceDisplayProps) {
  const {
    formattedSalePrice,
    formattedComparePrice
  } = useGeoPricing();
  return <div className={`flex items-center justify-center gap-3 font-heading ${className}`} data-id="element-179">
      {showOriginal && <span className="text-2xl md:text-3xl text-gray-400 line-through decoration-urgency-red decoration-2 opacity-80" data-id="element-180">
          {formattedComparePrice}
        </span>}
      <span className="text-4xl md:text-6xl font-extrabold text-brown-dark" data-id="element-181">
        {formattedSalePrice}
      </span>
    </div>;
}